import * as Yup from 'yup';

export const schema = (price: number) =>
  Yup.object().shape({
    price: Yup.number()
      .required('قیمت پیشنهادی ضروری می باشد.')
      .min(price, 'مبلغ پیشنهادی نمی‌تواند کمتر از قیمت پایه باشد.'),
  });
